import { string, object } from "yup";

export const schema = object().shape({
  password: string()
    .required()
    .min(8, "Password must be at least 8 characters"),
});
